



































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import NumKeyPad from '@/components/NumKeyPad.vue';
import Product from '@/lib/IProduct';
import PhoneNumber from '@/lib/common/objects/PhoneNumber';
import StarRating from '@/components/StarRating.vue';
import { analytics } from '@/lib/util/FirebaseConfig';
import { api } from '@/lib/KioskRestApi';
import { db } from '@/lib/ProductDatabase';
import { kioskSetup } from '@/lib/KioskSetup';
import { $nav } from '@/lib/KioskNavigation';
import _ from 'lodash';

type ScreenState = ('display'|'gather'|'sending'|'sent');

@Component({
  components: {
    NumKeyPad,
    StarRating,
  },
})
export default class ProductDetail extends Vue {

  // reactive properties
  screenState: ScreenState = 'display';
  mobileNumber: string = '';
  isProductLoaded: boolean = false;

  // injected properties
  @Prop({ required: true }) productId!: number;

  // non-reactive properties
  private product: Product | undefined;

  // watches
  @Watch('productId', {
    immediate: true,
  })
  onChangedProductId(newProductId: number) {
    if ( newProductId ) {
      this.product = db.getProductById(newProductId);
      this.isProductLoaded = true;
    }
  }

  // lifecycle

  // computed
  get isDisplayState() {
    return 'display' === this.screenState;
  }
  get isGatherState() {
    return 'gather' === this.screenState;
  }
  get isSendingState() {
    return 'sending' === this.screenState;
  }
  get isSentState() {
    return 'sent' === this.screenState;
  }
  get isLoadedWithoutProduct() {
    return this.isProductLoaded && (undefined === this.product);
  }
  get isLoadedWithProduct() {
    return this.isProductLoaded && (undefined !== this.product);
  }
  get parsedPhoneNumber(): PhoneNumber | null {
    try {
      return new PhoneNumber(this.mobileNumber);
    }
    catch (err) {
      return null;
    }
  }
  get isValidNumber(): boolean {
    return ( null !== this.parsedPhoneNumber );
  }
  get formattedMobileNumber(): string {
    if ( ! this.mobileNumber ) {
      return '';
    }
    const n = this.mobileNumber;
    if ( n.length > 6 ) {
      return n.substr(0, 3) + '-' + n.substr(3, 3) + '-' + n.substr(6, n.length - 6);
    }
    else if ( n.length > 3 ) {
      return n.substr(0, 3) + '-' + n.substr(3, n.length - 3);
    }
    else {
      return n;
    }
  }
  get productName(): string {
    return !!this.product ? this.product.name : '';
  }
  get whitelabelPath(): string {
    return db.getWhitelabelPath();
  }

  // methods
  formattedPrice(priceInCents: number): string {
    const dollars = Math.floor(priceInCents / 100);
    const cents = priceInCents - (dollars * 100);
    return '$' + dollars + '.' + ((cents < 10) ? '0' : '') + cents;
  }

  btnBuyNow() {
    this.screenState = 'gather';
    console.log(`logEvent begin_checkout: name=${this.productName} productId=${this.productId}`);
    analytics.logEvent("button", { kioskId: kioskSetup.kioskId, name: 'buy_now'});
    analytics.logEvent("begin_checkout", { kioskId: kioskSetup.kioskId, items: [{name: this.productName, id: String(this.productId)}] });
  }

  btnBack() {
    if ( 'gather' === this.screenState ) {
      this.screenState = 'display';
    }
    else {
      analytics.logEvent("button", { kioskId: kioskSetup.kioskId, name: 'back', productId: this.productId });
      $nav.back(this);
    }
  }

  btnBrowseMore() {
    analytics.logEvent("button", { kioskId: kioskSetup.kioskId, name: 'browse_more', productId: this.productId });
    $nav.to(this, '/products');
  }

  // btnTest() {
  //   this.sendTextToCustomer(new PhoneNumber('7654263893'), 'shampoo');
  // }

  async sendTextToCustomer(toPhoneNumber: PhoneNumber, productName: string) {
    try {
      await api.sendTextToCustomer(toPhoneNumber, productName);
    }
    catch (err) {
      console.log('failed to send text to customer: ', err);
    }
  }

  onDigit(digit: number) {
    if ( this.mobileNumber.length < 10 ) {
      this.mobileNumber = this.mobileNumber + digit;
    }
  }
  async onEnter() {
    const phoneNumber = this.parsedPhoneNumber;
    if ( null !== phoneNumber ) {
      console.log(`logEvent purchase: name=${this.productName} productId=${this.productId}`);
      analytics.logEvent("purchase", { kioskId: kioskSetup.kioskId, transaction_id: phoneNumber.toString(), items: [{name: this.productName, id: String(this.productId)}] });
      this.screenState = 'sending';
      await this.sendTextToCustomer(phoneNumber, this.productName);
      this.screenState = 'sent';
    }
  }
  onBackspace() {
    if ( this.mobileNumber.length > 0 ) {
      this.mobileNumber = this.mobileNumber.substr(0, this.mobileNumber.length - 1);
    }
  }

}


